module.exports = __webpack_public_path__ + "static/img/55.f40aa90.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/notice/55.png
// module id = JMr5
// module chunks = 1